export default __webpack_public_path__ + "static/media/portfolio.65b2df45.png";